import { computed, ComputedRef, inject, InjectionKey, provide, WatchSource } from "vue";

export type InputLabelVariant = 'default' | 'inline';

export const inputLabelVariantInjectionKey: InjectionKey<ComputedRef<InputLabelVariant | null>> = Symbol();

export function provideDefaultInputLabelVariant(variant: InputLabelVariant | WatchSource<InputLabelVariant>) {
	const provided = computed((): InputLabelVariant => {
		switch (typeof variant) {
			case 'string':
				return variant;
			case 'function':
				return variant();
			case 'object':
				return variant.value;
			default:
				return 'default';
		}
	});

	provide(inputLabelVariantInjectionKey, provided);
}

export function useDefaultInputLabelVariant() {
	return inject(
		inputLabelVariantInjectionKey,
		() => computed((): InputLabelVariant | null => null),
		true,
	);
}